import { isNil } from 'lodash';
import { createSelector } from 'reselect';
import { numericSorter } from '../../../utils/utils';
/**
 * Simple selector to extract cartLookup selected bank object from the sell transaction.
 * @param state
 * @returns {Bank|null} Currently selected bank
 */
export const getPlaidFailures = (state) => state.linkedBanks.failureHistory;

export const getPlaidAddBank = (state) => state.linkedBanks.addBankStatus;

export const getHasErrorType = (state) => state.linkedBanks.hasErrorType;

export const getErrorType = (state) => state.linkedBanks.errorType;

export const bankAddedSuccessfully = (state) =>
  state.linkedBanks.bankAdditionSuccess;

export const bankAddedPartially = (state) =>
  state.linkedBanks.bankAdditionPartialSuccess;

export const isBankDuplicated = (state) => state.linkedBanks.isBankDuplicate;
/**
 * Complex selector to extract the agreement map corresponding to the selected bank. or a 'default' agreement map
 * with empty lookups if no bank is selected.
 * @param state
 * @returns {AgreementMapEx}
 */
export const getPlaidFailureCount = createSelector(
  getPlaidFailures,
  (PlaidFailures) => {
    return PlaidFailures ? PlaidFailures.length : 0;
  }
);

export const getLastPlaidFailure = createSelector(
  getPlaidFailures,
  (PlaidFailures) => {
    if (isNil(PlaidFailures)) {
      return [];
    }
    return [...PlaidFailures].sort(numericSorter)[0];
  }
);
